import React, { Component } from "react";
import { Navigate } from "react-router-dom";

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";

import SubmissionView from "../../Submissions/SubmissionView/SubmissionView";

import { FormMapper } from "../../../../hoc/FormConfig";
import { customStyle } from "../../../../hoc/CustomStyle";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faCaretUp,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";

class Shortlist extends Component {
  state = {
    render: {
      loaded: false,
      content_type: "table", // table, form, create
      user_type: null,
      user_id: null,
    },

    table: {
      header: null,
      content: null,
      others: null,
    },

    view: {
      retrieve_id: null,
      header: null,
      content: null,
      status: null,
    },

    spinner: {
      toggle: false,
      msg: "",
    },

    internalMsg: {
      triggered: false,
      type: "",
      content: "",
    },

    externalMsg: {
      triggered: false,
      type: "",
      content: "",
    },

    selected: {
      app_id: faSort,
      type: faSort,
      citizenship: faSort,
      merit_score: faSort,
      supervisor_score: faSort,
      research_score: faSort,
      combined_score: faCaretDown,
      votes: faSort,
    },
  };

  constructor(props) {
    super(props);
    this.formHandler = this.formHandler.bind(this);
  }

  toggleSpinner(trigger, message) {
    this.setState({
      ...this.state,
      spinner: {
        toggle: trigger,
        msg: message,
      },
    });
  }

  messageHandler(msg_type, msg_content) {
    if (msg_type === "expired") {
      this.setState({
        ...this.state,
        externalMsg: {
          triggered: true,
          type: "error",
          content: msg_content,
        },
      });
    } else {
      this.setState({
        ...this.state,
        internalMsg: {
          triggered: true,
          type: msg_type,
          content: msg_content,
        },
      });
    }
  }

  loadpageHandler(content_type, content_id) {
    this.toggleSpinner(true, "null");

    // load profile information
    let accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      let params = {
        request_type: content_type,
        retrieve_id: content_id,
      };

      if (params) {
        // table
        axios({
          url:
            process.env.REACT_APP_AXIOS_URL + "fetch/shortlist/" + content_type,
          method: "post",
          auth: {
            username: accessToken,
            password: "unused",
          },
          data: {
            request_type: params.request_type,
            request_id: params.retrieve_id,
          },
        })
          .then((received) => {
            //console.log(received)

            this.toggleSpinner(false, "null");

            if (received.status === 200) {
              if (received.data.status) {
                let updatedStates = {};
                if (params.request_type === "table") {
                  updatedStates = {
                    ...this.state,
                    table: {
                      header: received.data.payload.header,
                      content: received.data.payload.content,
                      others: received.data.payload.others,
                    },
                    form: {
                      retrieve_id: null,
                      header: null,
                      content: null,
                    },
                  };
                } else if (params.request_type === "view") {
                  updatedStates = {
                    ...this.state,
                    view: {
                      ...this.state.view,
                      header: received.data.payload.header,
                      content: received.data.payload.content,
                      status: received.data.payload.outcome,
                    },
                  };
                }
                updatedStates = {
                  ...updatedStates,
                  render: {
                    loaded: true,
                    content_type: params.request_type,
                    user_type: this.props.grant_infor.user_type,
                  },
                };

                this.setState(updatedStates);
              } else {
                this.messageHandler("error", received.data.message);
              }
            } else {
              this.messageHandler(
                "error",
                "Unexpected error, contact site administrator if persist."
              );
            }
          })
          .catch((error) => {
            this.toggleSpinner(false, "null");

            if (error.response && error.response.status === 401) {
              this.messageHandler(
                "expired",
                "Session expired. Please log in again"
              );
            } else {
              this.messageHandler(
                "error",
                "An Unexpected error has occurred, please contact site admin if persists."
              );
            }
          });
      } else {
        this.toggleSpinner(false, "null");

        this.messageHandler(
          "error",
          "Invalid parameters where parameters are expected"
        );
      }
    } else {
      this.toggleSpinner(false, "null");

      this.messageHandler("expired", "Session expired, please login again");
    }

    this.setState({
      ...this.state,
      render: {
        ...this.state.render,
        loaded: false,
      },
    });
  }

  posthandler(post_type, post_id, post_mode) {
    this.toggleSpinner(true, "null");

    let accessToken = localStorage.getItem("access_token");

    if (accessToken) {
      axios({
        url: process.env.REACT_APP_AXIOS_URL + "post/shortlist/" + post_type,
        method: "post",
        auth: {
          username: accessToken,
          password: "unused",
        },
        data: {
          request_type: post_mode,
          request_meta: {
            grant_id: this.props.grant_infor.grant_id,
            app_id: post_id,
          },
        },
      })
        .then((received) => {
          this.toggleSpinner(false, "null");

          if (received.status === 200) {
            if (received.data.status) {
              this.loadpageHandler("table", null);
            } else {
              this.messageHandler("error", received.data.message);
            }
          } else {
            this.messageHandler(
              "error",
              "Unexpected error occurred, contact site admin if persist"
            );
          }
        })
        .catch((error) => {
          this.toggleSpinner(false, "null");

          if (error.response && error.response.status === 401) {
            this.messageHandler(
              "expired",
              "Session expired. Please log in again"
            );
          } else {
            this.messageHandler(
              "error",
              "An Unexpected error has occurred, please contact site admin if persists."
            );
          }
        });
    } else {
      this.toggleSpinner(false, "null");
      this.messageHandler("expired", "Session expired. Please log in again");
    }
  }

  downloadHandler(event, app_id) {
    console.log(event);
    const FileDownload = require("js-file-download");
    let accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      if (event === "download") {
        axios({
          url: process.env.REACT_APP_AXIOS_URL + "file/admin/download/single",
          method: "post",
          auth: {
            username: accessToken,
            password: "unused",
          },
          data: {
            request_id: app_id,
          },
          responseType: "arraybuffer",
        }).then((received) => {
          FileDownload(received.data, "app_" + app_id + ".zip");
        });
      } else if (event === "all") {
        axios({
          url: process.env.REACT_APP_AXIOS_URL + "file/admin/download/all",
          method: "post",
          auth: {
            username: accessToken,
            password: "unused",
          },
          data: {
            request_id: null,
          },
          responseType: "arraybuffer",
        }).then((received) => {
          FileDownload(received.data, "applications_all.zip");
        });
      } else {
        axios({
          url: process.env.REACT_APP_AXIOS_URL + "file/admin/download/summary",
          method: "post",
          auth: {
            username: accessToken,
            password: "unused",
          },
          data: {
            request_id: app_id,
          },
          responseType: "arraybuffer",
        }).then((received) => {
          FileDownload(received.data, "app_" + app_id + ".pdf");
        });
      }
    }
  }

  viewHandler(content_type, content_id) {
    this.toggleSpinner(true, "null");

    // load profile information
    let accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      let params = {
        request_type: content_type,
        retrieve_id: content_id,
      };

      if (params) {
        // table
        axios({
          url:
            process.env.REACT_APP_AXIOS_URL +
            "fetch/applications/" +
            content_type,
          method: "post",
          auth: {
            username: accessToken,
            password: "unused",
          },
          data: {
            request_type: params.request_type,
            request_id: params.retrieve_id,
          },
        })
          .then((received) => {
            //console.log(received)

            this.toggleSpinner(false, "null");

            if (received.status === 200) {
              if (received.data.status) {
                let updatedStates = {};

                updatedStates = {
                  ...this.state,
                  view: {
                    ...this.state.view,
                    header: received.data.payload.header,
                    content: received.data.payload.content,
                    status: received.data.payload.outcome,
                  },
                };

                updatedStates = {
                  ...updatedStates,
                  render: {
                    loaded: true,
                    content_type: params.request_type,
                    user_type: this.props.grant_infor.user_type,
                  },
                };

                this.setState(updatedStates);
              } else {
                this.messageHandler("error", received.data.message);
              }
            } else {
              this.messageHandler(
                "error",
                "Unexpected error, contact site administrator if persist."
              );
            }
          })
          .catch((error) => {
            this.toggleSpinner(false, "null");

            if (error.response && error.response.status === 401) {
              this.messageHandler(
                "expired",
                "Session expired. Please log in again"
              );
            } else {
              this.messageHandler(
                "error",
                "An Unexpected error has occurred, please contact site admin if persists."
              );
            }
          });
      } else {
        this.toggleSpinner(false, "null");

        this.messageHandler(
          "error",
          "Invalid parameters where parameters are expected"
        );
      }
    } else {
      this.toggleSpinner(false, "null");

      this.messageHandler("expired", "Session expired, please login again");
    }

    this.setState({
      ...this.state,
      render: {
        ...this.state.render,
        loaded: false,
      },
    });
  }

  resetHandler() {
    this.toggleSpinner(true, "null");

    let accessToken = localStorage.getItem("access_token");

    if (accessToken) {
      axios({
        url: process.env.REACT_APP_AXIOS_URL + "post/shortlist/reset",
        method: "post",
        auth: {
          username: accessToken,
          password: "unused",
        },
      })
        .then((received) => {
          this.toggleSpinner(false, "null");

          if (received.status === 200) {
            if (received.data.status) {
            } else {
              this.messageHandler("error", received.data.message);
            }
          } else {
            this.messageHandler(
              "error",
              "Unexpected error occurred, contact site admin if persist"
            );
          }
        })
        .catch((error) => {
          this.toggleSpinner(false, "null");

          if (error.response && error.response.status === 401) {
            this.messageHandler(
              "expired",
              "Session expired. Please log in again"
            );
          } else {
            this.messageHandler(
              "error",
              "An Unexpected error has occurred, please contact site admin if persists."
            );
          }
        });
    } else {
      this.toggleSpinner(false, "null");
      this.messageHandler("expired", "Session expired. Please log in again");
    }
  }

  formHandler(key) {
    this.loadpageHandler("table", key);
  }

  selectHandler(event, submission_id) {
    this.posthandler("table", submission_id, event.target.value); // au admin only
  }

  componentDidMount() {
    this.loadpageHandler("table", null);
  }

  sortByOrder(obj) {
    const object_array = Object.entries(obj).sort(
      (a, b) => a[1].order - b[1].order
    );
    const output_object = {};

    for (var i = 0; i < object_array.length; i++) {
      output_object[object_array[i][0]] = object_array[i][1];
    }
    return output_object;
  }

  changeIcon(key) {
    // FIXME Switch to setState() for code hygiene purposes.
    if (this.state.selected[key] === faSort) {
      //Selected some key other than the previously selected
      Object.keys(this.state.selected).forEach((_key, index) => {
        if (this.state.selected[_key] !== faSort)
          this.state.selected[_key] = faSort;
      });
      this.resetHandler();
      this.state.selected[key] = faCaretDown;
    } else if (this.state.selected[key] === faCaretUp)
      this.state.selected[key] = faCaretDown;
    else this.state.selected[key] = faCaretUp;
  }

  render() {
    let header = <b>Submissions</b>;
    let content = <p>Loading ...</p>;

    // message handling
    let msg = null;
    if (this.state.internalMsg.triggered) {
      if (this.state.internalMsg.type === "success") {
        msg = (
          <p style={customStyle.successMessage}>
            {this.state.internalMsg.content}
          </p>
        );
      } else if (this.state.internalMsg.type === "error") {
        msg = (
          <p style={customStyle.errorMessage}>
            {this.state.internalMsg.content}
          </p>
        );
      }
    }

    // redirect to login page if there is any error
    if (
      this.state.externalMsg.triggered &&
      this.state.externalMsg.type === "error"
    ) {
      localStorage.clear("access_token");
      return (
        <Navigate
          to="/"
          state={{
            message: {
              type: "error",
              content: this.state.externalMsg.content,
            },
          }}
        />
      );
    }

    // load display
    if (this.state.render.loaded) {
      if (this.state.render.content_type === "table") {
        const ordered_headers = this.sortByOrder(this.state.table.header);

        let num_columns = 0;
        const table_header = Object.entries(ordered_headers).map(
          ([key, entry], idx) => {
            num_columns++;
            if (
              key === "action" ||
              key === "app_name" ||
              key === "outcome" ||
              key === "reviews" ||
              key === "status"
            ) {
              return <th key={key}>{entry.name}</th>;
            } else {
              return (
                <th key={key}>
                  {entry.name}
                  <FontAwesomeIcon
                    icon={this.state.selected[key]}
                    variant="link"
                    onClick={(event) => {
                      this.changeIcon(key);
                      this.formHandler(key);
                    }}
                  />
                </th>
              );
            }
          }
        );

        let table_content = (
          <tr>
            <td colSpan={num_columns}>No applications found ...</td>
          </tr>
        );
        if (this.state.table.content.length > 0) {
          table_content = this.state.table.content.map((element, idx) => {
            const rowElement = Object.entries(ordered_headers).map(
              ([key, entry], row_idx) => {
                switch (key) {
                  case "app_name": {
                    let app_name = <p>N/A</p>;
                    app_name = (
                      <span
                        className="btn-link"
                        onClick={(event) =>
                          this.viewHandler("view", element["app_id"])
                        }
                      >
                        {element["app_name"]}
                      </span>
                    );
                    return <td key={row_idx}>{app_name}</td>;
                  }
                  case "outcome": {
                    let outcome = <p>N/A</p>;
                    outcome = Object.entries(element["outcome"]).map(
                      (value, index) => {
                        return <tr>{element["outcome"][index]}</tr>;
                      }
                    );
                    return <td key={row_idx}>{outcome}</td>;
                  }
                  case "status": {
                    if (this.state.render.user_type === "reviewer-final") {
                      return <td key={row_idx}>{element["status"]}</td>;
                    } else {
                      let status = <p>N/A</p>;
                      status = Object.entries(element["status"]).map(
                        (value, index) => {
                          return <tr>{element["status"][index]}</tr>;
                        }
                      );
                      return <td key={row_idx}>{status}</td>;
                    }
                  }
                  case "action": {
                    let action_item = (
                      <>
                        <Form.Control
                          as="select"
                          value=""
                          onChange={(event) =>
                            this.selectHandler(event, element["app_id"])
                          }
                        >
                          <option value="">(select)</option>
                          <option value="shortlist">Shortlist</option>
                          <option value="border">Borderline</option>
                          <option value="reject">Reject</option>
                        </Form.Control>
                      </>
                    );
                    return <td key={row_idx}>{action_item}</td>;
                  }
                  default:
                    return (
                      <td key={row_idx}>
                        {FormMapper[element[key]]
                          ? FormMapper[element[key]]
                          : element[key]}
                      </td>
                    );
                }
              }
            );

            return <tr key={idx}>{rowElement}</tr>;
          });
        }

        let download = null;
        if (this.state.render.user_type === "reviewer-final")
          download = (
            <div>
              <Button
                variant="info"
                onClick={() => this.downloadHandler("all", null)}
              >
                Download all
              </Button>
              <p></p>
            </div>
          );

        content = (
          <>
            {download}
            <Table striped bordered responsive>
              <thead>
                <tr>{table_header}</tr>
              </thead>
              <tbody>{table_content}</tbody>
            </Table>
          </>
        );
      } else if (this.state.render.content_type === "view") {
        header = <b>Application Summary</b>;
        content = (
          <SubmissionView
            formHandler={this.formHandler}
            downloadHandler={this.downloadHandler}
            grant_infor={this.props.grant_infor}
            sub_infor={this.state.view}
          />
        );
      }
    }

    return (
      <>
        {msg}
        <div style={customStyle.topBuffer20}>
          <Card>
            <Card.Header>{header}</Card.Header>
            <Card.Body>
              {this.state.spinner.toggle ? (
                <>
                  <Spinner animation="border" size="sm" /> Loading, please do
                  not refresh your page{" "}
                </>
              ) : null}
              {content}
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}

export default Shortlist;
